module.exports = __webpack_public_path__ + "img/footer.3d407007.jpg";